import { createRoutine } from 'redux-saga-routines';

export const fetchInventoryPackage = createRoutine('FETCH_INVENTORY_PACKAGE');
export const fetchInventoryPackages = createRoutine('FETCH_INVENTORY_PACKAGES');
export const createInventoryPackage = createRoutine('CREATE_INVENTORY_PACKAGE');
export const updateInventoryPackage = createRoutine('UPDATE_INVENTORY_PACKAGE');
export const deleteInventoryPackage = createRoutine('DELETE_INVENTORY_PACKAGE');

export const addInventoryPackageItem = createRoutine(
  'ADD_INVENTORY_PACKAGE_ITEM'
);
export const updateInventoryPackageItem = createRoutine(
  'UPDATE_INVENTORY_PACKAGE_ITEM'
);
export const deleteInventoryPackageItem = createRoutine(
  'DELETE_INVENTORY_PACKAGE_ITEM'
);

export const addInventoryPackageSku = createRoutine(
  'ADD_INVENTORY_PACKAGE_SKU'
);
export const fetchInventoryPackageSkus = createRoutine(
  'FETCH_INVENTORY_PACKAGE_SKUS'
);
export const deleteInventoryPackageSku = createRoutine(
  'DELETE_INVENTORY_PACKAGE_SKU'
);

export const fetchInventoryPackageAvailability = createRoutine(
  'FETCH_INVENTORY_PACKAGE_AVAILABILITY'
);

export const fetchInventoryPackagesAvailability = createRoutine(
  'FETCH_INVENTORY_PACKAGES_AVAILABILITY'
);

export const deleteInventoryPackageAvailability = createRoutine(
  'DELETE_INVENTORY_PACKAGE_AVAILABILITY'
);
